import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { App } from './App';
import { getBaseUrl } from './utils/routing';
import './styles/index.css';
import './styles/animations.css';
import './styles/brutalist.css';

// Import AOS (Animate On Scroll) library
import AOS from 'aos';
import 'aos/dist/aos.css';

// Initialize AOS with custom settings
AOS.init({
  duration: 800, // Animation duration in milliseconds
  easing: 'ease-out', // Easing function
  once: true, // Whether animation should happen only once
  offset: 100, // Offset (in px) from the original trigger point
  delay: 0, // Delay before animation starts
  anchorPlacement: 'top-bottom', // Which position of the element triggers animation
});

// Import StateExporter for development mode
if (import.meta.env.DEV) {
  import('./utils/stateExporter').then(({ StateExporter }) => {
    // StateExporter will be automatically exposed to window in development
    console.log('StateExporter loaded for development');
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter basename={getBaseUrl()}>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
); 